import createIcon from '../../createIcon';

/**
 * @component @name VerticalAlignCenter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCAxOUgxMVYyM0gxM1YxOUgxNkwxMiAxNUw4IDE5Wk0xNiA1SDEzVjFIMTFWNUg4TDEyIDlMMTYgNVpNNCAxMVYxM0gyMFYxMUg0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VerticalAlignCenter = createIcon('VerticalAlignCenter', [
  [
    'path',
    {
      d: 'M8 19H11V23H13V19H16L12 15L8 19ZM16 5H13V1H11V5H8L12 9L16 5ZM4 11V13H20V11H4Z',
      key: '1djd9k',
    },
  ],
]);

export default VerticalAlignCenter;
